$ = jQuery.noConflict()

$(document).ready(function () {
  const $form = $('#ligo-contact-form')
  if (!$form.length) return

  const $btn = $('#ligo-contact-btn')
  const $msg = $('#ligo-contact-msg')

  function showMsg(text, isError) {
    $msg
      .removeClass('hidden bg-green-100 text-green-800 bg-red-100 text-red-800')
      .addClass(isError ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800')
      .text(text)
  }

  $form.on('submit', function (e) {
    e.preventDefault()

    const nombre = $form.find('[name="nombre"]').val().trim()
    const apellido = ($form.find('[name="apellido"]').val() || '').trim()
    const empresa = ($form.find('[name="empresa"]').val() || '').trim()
    const email = $form.find('[name="email"]').val().trim()
    const mensaje = $form.find('[name="mensaje"]').val().trim()
    const segundo = empresa || apellido

    if (!nombre || !segundo || !email || !mensaje) {
      showMsg('Por favor completa todos los campos requeridos.', true)
      $msg.removeClass('hidden')
      return
    }

    if (typeof window.ligoContact === 'undefined') {
      showMsg('Error de configuración. Actualiza la página e intenta de nuevo.', true)
      $msg.removeClass('hidden')
      return
    }

    $btn.prop('disabled', true).text('Enviando…')
    $msg.addClass('hidden')

    $.post(window.ligoContact.ajaxUrl, {
      action: 'ligo_contact',
      nonce: window.ligoContact.nonce,
      nombre: nombre,
      apellido: apellido,
      empresa: empresa,
      email: email,
      telefono: ($form.find('[name="telefono"]').val() || '').trim(),
      producto: $form.find('[name="producto"]').val(),
      mensaje: mensaje,
    })
      .done(function (res) {
        if (res.success) {
          showMsg(res.data.message, false)
          $form[0].reset()
        } else {
          showMsg(res.data.message || 'Error al enviar. Intenta de nuevo.', true)
        }
      })
      .fail(function () {
        showMsg('Error de conexión. Intenta de nuevo.', true)
      })
      .always(function () {
        $msg.removeClass('hidden')
        $btn.prop('disabled', false).text('Solicitar ahora')
      })
  })
})
